// @mui
import { ListItemText, ListItemAvatar, ListItem } from "@mui/material";
import Iconify from "../iconify";

import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import React, { useEffect, useState } from "react";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import axios from "axios";
import moment from "moment";
import {
  Card,
  Stack,
  Button,
  Container,
  Typography,
  CircularProgress,
  Box,
  TextField,
  Tabs,
  Tab,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  Alert,
  OutlinedInput,
  Chip,
} from "@mui/material";
// ----------------------------------------------------------------------
const dateFormat = "YYYY-MM-DD HH:mm:ss";

export default function EditGeneralSettings(props) {
  const [tenantsResponse, setTenantsResponse] = useState(null);
  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_CLIENTS_API_BASE_URL}/clients/${process.env.REACT_APP_CLIENT_CODE}/tenants`
      )
      .then((response) => {
        if (response.data?.tenants) {
          setTenantsResponse(response.data.tenants);
        }
      });
  }, []);

  return (
    <Card sx={{ padding: 4, marginBottom: 4 }}>
      {props.loading ? (
        <Box
          sx={{ display: "flex", justifyContent: "center" }}
          style={{ padding: 20 }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Status</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="status"
                  value={props.state.status}
                  label="Status"
                  onChange={props.handleChangeStatus}
                >
                  <MenuItem value="DRAFT">DRAFT</MenuItem>
                  <MenuItem value="UPCOMING">UPCOMING</MenuItem>
                  <MenuItem value="IN_PLAY">IN_PLAY</MenuItem>
                  <MenuItem value="COMPLETE">COMPLETE</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DateTimePicker
                  label="Start UTC"
                  value={moment(props.state.start, dateFormat)}
                  onChange={props.handlePickemStartChange}
                  renderInput={(params) => <TextField {...params} />}
                />
              </LocalizationProvider>
            </Grid>
            {process.env.REACT_APP_NAME === "olybet" ? null : (
              <Grid item xs={4}>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <DateTimePicker
                    label="Allow Selections From UTC"
                    value={moment(
                      props.state.allow_selection_start,
                      dateFormat
                    )}
                    onChange={props.handlePickemAllowSelectionsStartChange}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </LocalizationProvider>
              </Grid>
            )}

            <Grid item xs={4}>
              <FormControl sx={{ width: 300 }}>
                <InputLabel id="demo-multiple-chip-label">Tenants</InputLabel>
                <Select
                  labelId="tenants-id"
                  id="tenants-id"
                  multiple
                  value={props.state?.tenants_prefixes}
                  onChange={props.handleChangeTenants}
                  input={
                    <OutlinedInput id="select-multiple-tenant" label="Chip" />
                  }
                  renderValue={(selected) => (
                    <Box
                      sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 0.5,
                      }}
                    >
                      {selected.map((value) => (
                        <Chip key={value} label={value} />
                      ))}
                    </Box>
                  )}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 48 * 4.5 + 8,
                        width: 250,
                      },
                    },
                  }}
                >
                  {tenantsResponse !== null &&
                    tenantsResponse.map((tenant) => (
                      <MenuItem key={tenant.prefix} value={tenant.prefix}>
                        {tenant.prefix}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Pickem Type
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="status"
                  value={props.state.pickem_type}
                  label="Status"
                  onChange={props.handleChangeType}
                >
                  <MenuItem value="0">Pickems</MenuItem>
                  <MenuItem value="1">Super 6</MenuItem>
                  <MenuItem value="2">Pepsi</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </>
      )}
    </Card>
  );
}
